// extracted by mini-css-extract-plugin
export default {"title":"AdminSettings_title__7D+kD"};